package Structs

import DataBase.UINKDBInterface
import Utils.DocType
import Utils.PayMethod
import Utils.fixJsonInternal
import kotlinx.serialization.Serializable
import myName
import kotlin.math.abs
import kotlin.math.min

@myName("ClientLightPay")
@Serializable
sealed class ClientLightPay(


) : InformationBase() {
    @myName("id")
    abstract val id: Int

    @myName("client_id")
    abstract val client_id: Int

    @myName("value")
    abstract val value: Float
    abstract val date: String

    @myName("document_date")
    abstract val document_date: String
    abstract val action_time: String
    abstract val ref_id: String
    /** "id:left:paid,..." marks — which invoices this receipt closed. Empty when unknown. */
    open val tax_note_id: String get() = ""
    var isClient = true

    override fun getConnectedDocType(): Int {
        return if (isClient) DocType.PAY_NOTE.state else DocType.SUPPLIER_PAYMENT.state
    }

    override fun getConnectedDate(): String {
        return document_date
    }

    override fun getConnectedDateTime(): String {
        return date
    }

    override fun getConnectedId(): Int {
        return id
    }

    override fun getConnectedEntId(): Int {
        return client_id
    }

    override fun getConnectedValue(): Float {
        return value
    }

    override fun getConnectedName(): String {
        val ent = if (isClient) {
            UINKDBInterface.activeDB.getClient(client_id).first
        } else {
            UINKDBInterface.activeDB.getSupplier(client_id).first
        }
        return ent?.let {
            if (it.branch != -1 && it.master != -1) it.getName(
                document_date
            ) else it.getBusinessName(document_date)
        } ?: ""
    }

    override fun toString(): String {
        return document_date.toString().split(" ").reversed().joinToString(" ")
    }

    override fun getConnectedPayment(): Float {
        return value
    }

    @myName("getClient")
    fun getClient(): Client {
        return UINKDBInterface.activeDB.getClient(client_id).first!!
    }
    @myName("getSupplier")
    fun getSupplier(): Supplier {
        return UINKDBInterface.activeDB.getSupplier(client_id).first!!
    }
}

@myName("ClientLightPayImp")
@Serializable
class ClientLightPayImp(
    override val id: Int,
    override val client_id: Int,
    override val value: Float,
    override val date: String,
    override val document_date: String, override val action_time: String = "", override val ref_id: String="",
    override val tax_note_id: String = "",
) : ClientLightPay() {

}

@myName("ClientPay")
@Serializable
data class ClientPay(
    override val id: Int,
    override val client_id: Int,
    override val value: Float,
    override val date: String,
    override val document_date: String,
    val details: String,
    val payment_data_raw: String,
    override var tax_note_id: String,
    val active: Int,
    var external_details: String = "",
    val agent: String = "",
    val driver_id: Int? = null,
    override val ref_id: String="",

    override val action_time: String = "",
) : ClientLightPay() {
    val paymentsData: List<PaymentData> = PaymentData.createFromJson(payment_data_raw)
    val ClientStaticData = Structs.ClientStaticData.createFromJson(details)
    var taxNotes: MutableList<Int> = mutableListOf()
    var taxNotesAmounts: MutableList<Float?> = mutableListOf()
    var taxNotesPays: MutableList<Float?> = mutableListOf()



    init {
        external_details = fixJsonInternal(external_details)
        if (!tax_note_id.isNullOrEmpty()) {
            for (i in tax_note_id.split(",")) {
                val splitted = i.split(":")
                val first = splitted[0].toInt()
                var second: Float? = null
                var third: Float? = null
                if (splitted.size > 1) {
                    second = splitted[1].toFloat()
                }
                if (splitted.size > 2) {
                    third = splitted[2].toFloat()
                }
                taxNotes.add(first)
                taxNotesAmounts.add(second)
                taxNotesPays.add(third)
            }

        }
    }

    /**
     * User-facing invoice numbers for this receipt. [taxNotes] stays the internal
     * ERP ids used for linking; supplier invoices show [ClientTaxNote.displayDocId]
     * (printed אסמכתא) when that tax note is already in memory.
     */
    @myName("displayTaxNoteIds")
    fun displayTaxNoteIds(): List<String> {
        if (taxNotes.isEmpty()) return emptyList()
        val db = UINKDBInterface.activeDB
        val sup = !isClient
        val pos = taxNotes.filter { it > 0 }
        val neg = taxNotes.filter { it < 0 }.map { abs(it) }
        val loaded = mutableMapOf<Int, ClientTaxNote>()
        if (pos.isNotEmpty()) {
            db.getClientTaxNote(ids = pos, type = 0, sup = sup).first.forEach { loaded[it.id] = it }
        }
        if (neg.isNotEmpty()) {
            db.getClientTaxNote(ids = neg, type = 2, sup = sup).first.forEach { loaded[it.id] = it }
        }
        return taxNotes.map { raw ->
            val note = loaded[abs(raw)]
            val shown = note?.displayDocId() ?: abs(raw).toString()
            if (raw < 0 && !shown.startsWith("-")) "-$shown" else shown
        }
    }

    @myName("getDriver")
    fun getDriver(): Agent? {
        return driver_id?.let {
            UINKDBInterface.activeDB.getAgentBy(it, null, driver = true).first
        }
    }

    fun getInverseTaxNoteTriple(toMap: Map<Int, ClientTaxNote>?=null): String {
        return taxNotes.zip(taxNotesAmounts.zip(taxNotesPays)).map {
            val tn = toMap?.get(it.first)
            if (it.second.first==null || it.second.second == null) {
                "${it.first}"
            } else
                "${it.first}:${min((tn?.value_left?:it.second.first!!) + it.second.second!!,(tn?.total_value?: Float.MAX_VALUE))}:${-it.second.second!!}"

        }.joinToString(",")
    }

    override fun getConnectedAgent(): String {
        return agent
    }
    override fun getConnectedPaymentCash(): Float {
        return paymentsData.filter { it.payMethod == PayMethod.CASH }.sumOf { it.value.toDouble() }.toFloat()
    }

    override fun getConnectedPaymentCredit(): Float {


        return paymentsData.filter { it.payMethod == PayMethod.CARD }.sumOf { it.value.toDouble() }.toFloat()
    }

    override fun getConnectedPaymentCheck(): Float {

        return paymentsData.filter { it.payMethod == PayMethod.CHECK || it.payMethod == PayMethod.FAST_CHECK }
            .sumOf { it.value.toDouble() }.toFloat()
    }

    override fun getConnectedPaymentBank(): Float {

        return paymentsData.filter { it.payMethod == PayMethod.BANK || it.payMethod == PayMethod.BANK_FULL || it.payMethod == PayMethod.BIT }
            .sumOf { it.value.toDouble() }.toFloat()
    }

    override fun getConnectedPaymentMass(): Float {
        return paymentsData.filter { it.payMethod == PayMethod.MASS_BAMACOR  }
            .sumOf { it.value.toDouble() }.toFloat()
    }
    override fun isActive(): Boolean {
        return active == 1
    }

    @myName("getAgentId")
    fun getAgentId(): Int? {
        return UINKDBInterface.activeDB.getAgentBy(name = agent, id = null).first?.id
    }

    override fun getConnectedName(): String {
        return if (isClient) UINKDBInterface.activeDB.getClient(client_id).first?.let {
            if (it.branch != -1 && it.master != -1) it.getName(
                document_date
            ) else ClientStaticData.business_name
        } ?: ClientStaticData.business_name else ClientStaticData.business_name
    }

    fun getSumByType(p: List<PayMethod>): Float {
        return paymentsData.filter { it.payMethod in p }
            .sumOf { it.value.toDouble() }.toFloat()
    }

    override fun getComments(): String {
        return external_details
    }

    override fun signData(): NoteSignHolder? =
        UINKDBInterface.activeDB.getSignOffline(id, getConnectedDocType()).first

    override fun digiSign(): Boolean = signData()?.digi_sign == 1

    override fun digiPhoto(): Boolean = photoCount() > 0

    override fun photoCount(): Int = NoteSignHolder.count(signData()?.digi_photo)

    fun getSumListByType(p: List<PayMethod>): List<Float> {
        return paymentsData.filter { it.payMethod in p }.map {
            it.value
        }
    }

    fun getAllCheckDates(): List<String> {
        return paymentsData.filter { it.payMethod == PayMethod.CHECK }.map { it.check_date }
    }

}
